<style lang="scss">
.menu-title {
	cursor: pointer;
	user-select: none;
	padding: 2px 12px 2px 6px;
	float: unset !important;
	&:hover {
		background-color: #d5e8fc;
	}
}

.menu-node-btn {
	display: inline-block;
	float: right;
	button {
		margin-right: 8px;
	}
}

.menu-title-active {
	background-color: #d5e8fc;
}
</style>

<template>
	<div>
		<vTree
			style="min-height:70vh;"
			:data="getNodes"
			:render="renderNode"
			ref="tree"
		></vTree>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { HttpGetCategory, HttpGetCategoryNewCode } from '@/service/billing';
import { HttpCategory } from '@mods/service/dictionary';

export default {
	data() {
		return {
			operateId: null,
			linkIndex: "",
            dataList:'',
            categoryList:[],
		};
    },
    created(){
        this.getDetail()
    },
	computed: {
		// ...mapGetters('dictionary', ['getBillcategory']),
		getNodes() {
			const data = JSON.parse(JSON.stringify(this.categoryList))
			const Nodes = [];
			data.forEach(item => {
				const parentId = item.parentId;
				if (!parentId) return Nodes.push(item);
				const parent = data.find(function (item) {
					return parentId === item.id;
				});
				if (!parent) return;
				const children = parent.children;
				if (children) {
					children.push(item);
				} else {
					parent.children = [item];
				}
			});
			Nodes.forEach((item) => {
				item.expand = true;
			})
			return Nodes;
		},
	},
	methods: {
        getDetail(){
            HttpCategory().then(res=>{
                this.categoryList = res.data
            })
        },
		renderNode(h, {
			root,
			node,
			data
		}) 
		{
			let active = this.operateId === data.id;
			return h('div', {
				class: [
					'menu-title',
					{
						'menu-title-active': active
					}
				],

				attrs: {
					title: this.$t('fbb.accountmanage.double_click_edit_node', { defaultValue: "双击编辑该节点" })
				}
			}, [data.name,
			h('span', {
				class: 'menu-node-btn'
			},
				[
					data.level < 3 && (this.handleAuth('fbb.billing.catagorytypeedit') || data.level > 1) ? h('vButton', {
						attrs: {
							title: this.$t('fbb.accountmanage.add_child_node', { defaultValue: "添加子节点" }),
							icon: 'add',
							theme: 'primary',
							size: 'small',
						},
						on: {
							click: (event) => {
								event.stopPropagation();
								this.appendNode(root, node, data);
							},
						},
					}) : null,
					
					data.parentId && (this.handleAuth('fbb.billing.catagorytypeedit') || data.level > 2) ? h('vButton', {
						props: {
							icon: 'create',
							size: 'small',
						},
						attrs: {
							title: this.$t('fbb.accountmanage.edit_node', { defaultValue: "编辑该节点" })
						},
						on: {
							click: (event) => {
								event.stopPropagation();
								this.getNode(root, node, data);
							},
						},
					}) : null,
				]
			),
				])
		},
		handleKeepStatus() {
			if (linkIndex) {
				this.$refs.tree.status = linkIndex.split(',')
			}
		},
		getNode(root, node, data) {
			// console.log(node, data)
			this.operateId = data.id;
			this.$emit('on-data', data, 'edit');
		},
		appendNode(root, node, data) {
			console.log(data.level)
			this.operateId = data.id;
			this.$emit('on-data', data, 'add');
		},
	},
};
</script>
